import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiGetNoAuth, ApiPostNoAuth, CommonRequest, CreateRoute } from "../../ApiSetUp/CommonApi";
import { api, BaseUrl } from "../../ApiSetUp/AuthApi";


//--------------------- Po Apis ------------------------------
export const addPurchaseOrder = createAsyncThunk(
    "addPurchaseOrder",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.addPurchaseOrder, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const downloadPO = createAsyncThunk(
    "downloadPO",
    async (body) => {
        return CommonRequest(
            CreateRoute(BaseUrl, api.downloadPO),
            body,
            "POST",
            {},
            { responseType: "blob", }
        )();
    }
);
export const downloadSheet = createAsyncThunk(
    "downloadSheet",
    async (body) => {
        return CommonRequest(
            CreateRoute(BaseUrl, api.downloadSheet),
            body,
            "POST",
            {},
            { responseType: "blob", }
        )();
    }
);
export const getPurchaseOrders = createAsyncThunk(
    "getPurchaseOrders",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getPurchaseOrders, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getPODocumetsPoNumbers = createAsyncThunk(
    "getPODocumetsPoNumbers",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getPODocumetsPoNumbers, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getAdvanceLicensesForPODoc = createAsyncThunk(
    "getAdvanceLicensesForPODoc",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getAdvanceLicensesForPODoc, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getPurchaseOrderById = createAsyncThunk(
    "getPurchaseOrderById",
    async (body) => {
        return ApiGetNoAuth(BaseUrl, api.getPurchaseOrderById + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const deletePurchaseOrder = createAsyncThunk(
    "deletePurchaseOrder",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.deletePurchaseOrder + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const changeStatusOfPurchaseOrder = createAsyncThunk(
    "changeStatusOfPurchaseOrder",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.changeStatusOfPurchaseOrder, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getPoDcumentsByPoNumber = createAsyncThunk(
    "getPoDcumentsByPoNumber",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getPoDcumentsByPoNumber, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const updatePurchaseOrder = createAsyncThunk(
    "updatePurchaseOrder",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.updatePurchaseOrder, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const downloadpurchaseOrderExcel = createAsyncThunk(
    "downloadpurchaseOrderExcel",
    async (body) => {
        return CommonRequest(
            CreateRoute(BaseUrl, api.downloadpurchaseOrderExcel),
            body,
            "POST",
            {},
            { responseType: "blob" }
        )();
    }
);

//--------------------- Po Documents Apis ------------------------------
export const addPODocument = createAsyncThunk(
    "addPODocument",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.addPODocument, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getPODocuments = createAsyncThunk(
    "getPODocuments",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getPODocuments, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getPODocumentById = createAsyncThunk(
    "getPODocumentById",
    async (body) => {
        return ApiGetNoAuth(BaseUrl, api.getPODocumentById + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const deletePODocument = createAsyncThunk(
    "deletePODocument",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.deletePODocument + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const updatePODocument = createAsyncThunk(
    "updatePODocument",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.updatePODocument, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
